// connection state
enum ConnectionState {
  NOT_CONNECTED = 0,
  CONNECTING = 1,
  CONNECTED = 2,
  AUTHENTICATED = 3
}

export default ConnectionState;
